var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55.8809,
    height: 55.8809,
    rx: 14,
    fill: "#FEEEEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 34L15.2929 33.2929C15.1054 33.4804 15 33.7348 15 34H16ZM29.5 20.5L30.2071 19.7929C29.8166 19.4024 29.1834 19.4024 28.7929 19.7929L29.5 20.5ZM35.5 26.5L36.2071 27.2071C36.5976 26.8166 36.5976 26.1834 36.2071 25.7929L35.5 26.5ZM22 40V41C22.2652 41 22.5196 40.8946 22.7071 40.7071L22 40ZM16 40H15C15 40.5523 15.4477 41 16 41V40ZM16 16V15C15.4477 15 15 15.4477 15 16H16ZM40 16H41C41 15.4477 40.5523 15 40 15V16ZM40 40V41C40.5523 41 41 40.5523 41 40H40ZM28 39C27.4477 39 27 39.4477 27 40C27 40.5523 27.4477 41 28 41V39ZM15 28C15 28.5523 15.4477 29 16 29C16.5523 29 17 28.5523 17 28H15ZM16.7071 34.7071L30.2071 21.2071L28.7929 19.7929L15.2929 33.2929L16.7071 34.7071ZM28.7929 21.2071L34.7929 27.2071L36.2071 25.7929L30.2071 19.7929L28.7929 21.2071ZM34.7929 25.7929L21.2929 39.2929L22.7071 40.7071L36.2071 27.2071L34.7929 25.7929ZM22 39H16V41H22V39ZM17 40V34H15V40H17ZM24.2929 25.7071L30.2929 31.7071L31.7071 30.2929L25.7071 24.2929L24.2929 25.7071ZM16 17H40V15H16V17ZM39 16V40H41V16H39ZM40 39H28V41H40V39ZM17 28V16H15V28H17Z",
    fill: "#DA1F3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAccount);
export default __webpack_public_path__ + "static/media/create-account.d2ca1ca6a0edcb7abd0f88d629c8c082.svg";
export { ForwardRef as ReactComponent };